<template>
  <div class="asSpacer"></div>
</template>

<style>
  .asSpacer {
    margin: auto;
  }
</style>
